import { createFileRoute, Navigate, Outlet } from "@tanstack/react-router";
import { toast } from "react-toastify";

import { useDriver } from "@/contexts";
import { queueService } from "@/services/queue";

export const Route = createFileRoute("/app/checkin")({
  component: CheckinLayout,
  loader: async ({ context }) => {
    const store = context.store.getState();
    const { auth } = store;

    const driverId = auth.driver?.id;
    const companyId = auth.driver?.company.id;

    let position = null;

    if (!companyId) return { position };

    const { data } = await queueService.query.getQueueByCompanyId(+companyId);
    const index = data.findIndex((x: { driver: { id: number } }) => x.driver?.id === Number(driverId));

    if (index >= 0) {
      position = index + 1;
    }

    return { position };
  }
});

export function CheckinLayout() {
  const { position } = Route.useLoaderData();
  const { driverCheckIn, isDriverIPAuthorized, settingsCompany } = useDriver();

  const hasPosition = position !== null;

  if (!settingsCompany?.enableCheckin || (!isDriverIPAuthorized && !hasPosition && !driverCheckIn?.driverCheckInActive)) {
    if (!toast.isActive("checkin-permission-error")) toast.error("Você não tem permissão para acessar esta página.", { toastId: "checkin-permission-error" });
    return <Navigate to="/app" replace />;
  }

  return <Outlet />;
}
